import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postAssignTeacherReserveAwardPromocode(awardId: string): Promise<{ promocode: string }> {
    const { apiPostAssignTeacherReserveAwardPromocode } = apiConfig.getStaticUrls();

    return postFetch(apiPostAssignTeacherReserveAwardPromocode, { awardId });
}
